jQuery.ajaxPrefilter(function (options, originalOptions, jQXHR) {
  // Allow cross-domain Cookies via AJAX
  if (options.url.indexOf(window.Sparkle.apiHost) > -1) {
    options.xhrFields = { withCredentials: true };
  }
});
